export const CONFIGURATION = {
  path: 'configuration',
  data: {
    breadcrumb: 'MENU_ADMIN.CONFIGURATION',
    icon: 'pi pi-cog',
    clickable: false,
    openTab: true
  },
  generalData: {
    path: 'general',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.GENERAL_DATA',
      icon: 'pi pi-info-circle',
      openTab: true
    }
  },
  users: {
    path: 'users',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.USERS',
      icon: 'pi pi-users',
      openTab: true
    }
  },
  rolesPermissions: {
    path: 'roles',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.ROLES_PERMISSIONS',
      icon: 'pi pi-key',
      openTab: true
    }
  },
  communicationTemplates: {
    path: 'templates',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.COMMUNICATION_TEMPLATES',
      icon: 'pi pi-file-edit',
      openTab: true
    }
  },
  administratorProfile: {
    path: 'admin-profile',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.ADMINISTRATOR_PROFILE',
      icon: 'pi pi-user-edit',
      openTab: true
    }
  },
  externalIntegrations: {
    path: 'integrations',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.EXTERNAL_INTEGRATIONS',
      icon: 'pi pi-link',
      openTab: true
    }
  },
  resetData: {
    path: 'reset',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.RESET_DATA',
      icon: 'pi pi-refresh',
      openTab: true
    }
  },
  deleteCondominium: {
    path: 'delete-condominium',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.DELETE_CONDOMINIUM',
      icon: 'pi pi-trash',
      openTab: true
    }
  },
  membership: {
    path: 'membership',
    data: {
      breadcrumb: 'MENU_ADMIN.CONFIGURATION_SUB.MEMBERSHIP',
      icon: 'pi pi-id-card',
      openTab: true
    }
  }
};

